import { Component, OnInit, Input, ViewChild, ElementRef, ViewChildren, HostListener, QueryList } from '@angular/core';
import { IButtonData } from '../../shared/components/bg-button/bg-button.component';
import { IPictureData } from '../../shared/components/picture/picture.component';
import { IUProperty } from '../lib/public_api';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MqService } from '../../service/mq.service';
import { IRteStyleSettings } from '../../shared/interface/rte-style-settings';
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';

interface ILicenseV2PanelData {
  items?: IUProperty<ILicenseV2Items[]>;
}

interface ILicenseV2Items {
  header?: IUProperty<string>;
  backgroundImage?: IUProperty<IPictureData>;
  price?: IUProperty<string>;
  priceFontColor?: IUProperty<string>;
  priceFontSize?: IUProperty<string>;
  priceFontWeight?: IUProperty<string>;
  link?: IUProperty<IButtonData>
  linkColor?: IUProperty<string>;
  information?: IUProperty<string>;
  items?: IUProperty<ILicenseBullets[]>;

  rteStyleSettingsComposition?: IRteStyleSettings;
  titleStyleSettingsComposition?: ITitleStyleSettings;
}

interface ILicenseBullets {
  description: IUProperty<string>;

  rteStyleSettings?: IRteStyleSettings;
}

enum infoState {
  opened = 'opened',
  closed = 'closed'
}

@Component({
  selector: 'app-license-v2-panel',
  templateUrl: './license-v2-panel.component.html',
  styleUrls: ['./license-v2-panel.component.less'],
  animations: [
    trigger('info', [
      state('opened', style({
        height: '*',
        opacity: '1',
      })),
      state('closed', style({
        height: '0',
        opacity: '0',
      })),
      transition('* => *', animate('.2s'))
    ]),
    trigger('arrow', [
      state('opened', style({
        transform: 'rotate(180deg)'
      })),
      state('closed', style({
        transform: 'rotate(0deg)',
      })),
        transition('* => *', animate('.2s'))
    ])
  ]
})
export class LicenseV2PanelComponent implements OnInit {
  @Input() data: ILicenseV2PanelData;
  @ViewChild('panelEl', { static: false }) panelEl: ElementRef<HTMLElement>;
  @ViewChild('imageEl', { static: false }) imageEl: ElementRef<HTMLElement>;
  @ViewChildren('cardImageEl') cardImageEl;
  @ViewChildren('bulletEl') bulletEls: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren('itemEl') itemEls: QueryList<ElementRef<HTMLElement>>;

  @HostListener('window:resize', ['$event']) onResize(event?) {
    this.checkIfMobile();
    this.ngAfterViewInit();
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelEl.nativeElement.offsetTop) {
      this.loadMedia();
    }
  }

  isMobile: boolean;
  items: any;
  bulletLeft: any;
  bulletRight: any;
  scrollPosition: number = null;

  constructor(private mq: MqService) { }

  ngOnInit() {
    if (this.data && this.data.items && this.data.items.value) {
      this.items = this.data.items.value;

      this.items.forEach(item => {
        item.state = infoState.closed;
      })

      this.checkIfMobile();
      this.spliceArray();
    }
  }

  ngAfterViewInit(): void {
    this.scrollPosition = window.pageYOffset;
    if ((this.scrollPosition + window.outerHeight) > this.panelEl.nativeElement.offsetTop) {
      this.loadMedia();
    }
    this.setCustomItemStyling();
  }

  setCustomItemStyling() {

    this.itemEls.forEach((ref, i) => {
      const itemData = this.data.items.value[i];

      if (!itemData) return;

      applyRteSettings(itemData, ref);
      applyTitleSettings(itemData, ref);

      if (itemData.priceFontColor && itemData.priceFontColor.value) {
        ref.nativeElement.style.setProperty("--licence-v2-price-font-color", itemData.priceFontColor.value);
      }
      if (itemData.priceFontSize && itemData.priceFontSize.value) {
        ref.nativeElement.style.setProperty("--licence-v2-price-font-size", itemData.priceFontSize.value + 'px');
      }
      if (itemData.priceFontWeight && itemData.priceFontWeight.value) {
        ref.nativeElement.style.setProperty("--licence-v2-price-font-weight", itemData.priceFontColor.value);
      }
    });

    let counter = 0;
    const bulletElements = this.bulletEls.toArray();

    this.data.items.value.forEach((itemData) => {
      itemData.items.value.forEach((bulletData) => {
        applyRteSettings(bulletData, bulletElements[counter]);
        counter++;
      });
    });
  }

  loadMedia() {
    if (this.data && this.data.items && this.data.items.value && this.imageEl && this.imageEl.nativeElement) {
      this.imageEl.nativeElement.style.backgroundImage = 'url(' + this.data.items.value[0].backgroundImage.value.src + ')';
      this.imageEl.nativeElement.style.backgroundSize = 'cover';
      this.imageEl.nativeElement.style.backgroundRepeat = 'no-repeat';
    }

    if (this.data && this.data.items && this.data.items.value && this.cardImageEl && this.cardImageEl) {
      let i = this.isMobile ? 0 : 1;
      this.cardImageEl._results.forEach(item => {
        item.nativeElement.style.backgroundImage = 'url(' + this.items[i].backgroundImage.value.src + ')';
        item.nativeElement.style.backgroundSize = 'cover';
        item.nativeElement.style.backgroundRepeat = 'no-repeat';
        ++i;
      });
    }
  }

  spliceArray() {
    if (this.items[0].items.value.length >= 2) {
      this.bulletLeft = this.items[0].items.value.slice(0, Math.round(this.items[0].items.value.length / 2));
      this.bulletRight = this.items[0].items.value.slice(Math.round(this.items[0].items.value.length / 2));
    } else {
      this.bulletLeft = this.items[0].value;
    }
  }

  toggleItems(item: any) {
    item.state === 'opened' ? item.state = infoState.closed : item.state = infoState.opened;
  }s

  checkIfMobile() {
    if (this.mq.isMidi()) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

}
